var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.state)?_c('pre',{staticClass:"pa-2",staticStyle:{"white-space":"pre-wrap","background":"gray","color":"white","border-radius":"10px","overflow":"auto","font-size":"14px","max-height":"400px","margin-top":"5px"}},[_vm._v(_vm._s(_vm.state.state))]):(_vm.error)?_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.error.message))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }